import { useState, useRef } from "react";
import  { cdnInstance } from "../../../axiosInterceptor";
import * as Yup from "yup";
import { useFormik } from "formik";
import { FiUploadCloud, FiFile, FiXCircle } from "react-icons/fi";

const ZipUpload = () => {
 const inputRef = useRef(null);

 const [file, setFile] = useState(null);
 const [progress, setProgress] = useState(0);
 const [isUploading, setIsUploading] = useState(false);
 const [error, setError] = useState("");
 const [success, setSuccess] = useState("");
const validationSchema = Yup.object({
  file: Yup.mixed()
    .required("ZIP file required")
    .test("fileFormat", "Only .zip allowed", (value) => {
      if (!value) return false;

      const isZipType =
        value.type === "application/zip" ||
        value.type === "application/x-zip-compressed";

      const isZipName = value.name?.toLowerCase().endsWith(".zip");

      return isZipType || isZipName;
    })
    .test("fileSize", "Max file size is 100MB", (value) => {
      if (!value) return false;
      return value.size <= 100 * 1024 * 1024; 
    }),
});
 const formik = useFormik({
  initialValues: { file: null },
  validationSchema,
  onSubmit: (values) => handleUpload(values.file),
 });

 const handleFile = (file) => {
  setFile(file);
  setError("");
  setSuccess("");
  formik.setFieldValue("file", file);
 };

 const handleUpload = async (file) => {
  setIsUploading(true);
  setProgress(0);
  setError("");
  setSuccess("");

  const formData = new FormData();
  formData.append("zip", file);

  const timer = setInterval(() => {
    setProgress((prev) => (prev < 90 ? prev + 10 : prev));
  }, 300);

  try {
    const res = await cdnInstance.post(`importzip?label=zip`, formData);
    if (res.data?.isSuccess) {
      setProgress(100);
      setSuccess("ZIP uploaded successfully!");
      setTimeout(() => {
        setFile(null);
        formik.resetForm(); 
        setProgress(0);
        setError("");
        setSuccess("");
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      }, 10000); 
    } else {
      setError("Upload failed");
    }
  } catch (err) {
    setError("Something went wrong");
  } finally {
    clearInterval(timer);
    setIsUploading(false);
  }
};

 return (
  <div className="card shadow-lg border-0">
   <div style={{ padding: "20px" }}>
    <form onSubmit={formik.handleSubmit}>
     <div
      onClick={() => inputRef.current.click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
       e.preventDefault();
       handleFile(e.dataTransfer.files[0]);
      }}
      onMouseEnter={(e) => {
       e.currentTarget.style.background = "#edf2f7";
       e.currentTarget.style.borderColor = "#4f46e5";
      }}
      onMouseLeave={(e) => {
       e.currentTarget.style.background = "#f9fafb";
       e.currentTarget.style.borderColor = "#6c757d";
      }}
      style={{
       border: "2px dashed #6366f1",
       borderRadius: "14px",
       padding: "65px",
       textAlign: "center",
       cursor: "pointer",
       background: "#f8fafc",
       transition: "0.3s",
      }}
     >
      <FiUploadCloud size={50} color="#4f46e5" className="mb-3" />

      {!file ? (
       <>
        <p style={{ fontWeight: 500, marginTop: "10px" }}>Drag & Drop ZIP</p>
        <small style={{ color: "#6b7280" }}>or click to browse</small>
       </>
      ) : (
       <div className="mt-3 d-flex justify-content-center align-items-center gap-2">
        <FiFile />
        <span style={{ fontWeight: 500 }}>{file.name}</span>
        <FiXCircle
         color="red"
         style={{ cursor: "pointer" }}
         onClick={(e) => {
          e.stopPropagation();
          setFile(null);
          formik.setFieldValue("file", null);
         }}
        />
       </div>
      )}

      <input
       type="file"
       ref={inputRef}
       hidden
       accept=".zip"
       onChange={(e) => handleFile(e.target.files[0])}
      />
     </div>
     {formik.errors.file && (
      <p style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
       {formik.errors.file}
      </p>
     )}
     {error && <div className="alert alert-danger mt-4">{error}</div>}
     {success && <div className="alert alert-success mt-4">{success}</div>}
     {isUploading && (
      <div className="progress mt-4" style={{ height: "18px" }}>
       <div
        className="progress-bar progress-bar-striped progress-bar-animated"
        style={{ width: `${progress}%` }}
       >
        {progress}%
       </div>
      </div>
     )}
   <button
  type="submit"
  disabled={!file || isUploading}
  className="btn w-100 mt-4 custom-outline-btn"
>
  {isUploading ? "Uploading..." : "Upload ZIP"}
</button>
    </form>
   </div>
  </div>
 );
};

export default ZipUpload;
